export default __webpack_public_path__ + "static/media/topMenu_fullscreen.dbd06c37.svg";